import { addDays } from "./utils/timeFormatters"








export function DatasEntregas({ entrega, entregaBarHeight, xScale, y }: { entrega: any, xScale: any, y: number, entregaBarHeight: number }) {



    return (<g >
        <rect
            x={xScale(new Date(entrega.realDeliveryDate))}
            y={y}
            width={xScale(addDays(new Date(entrega.realDeliveryDate), 1)) - xScale(new Date(entrega.realDeliveryDate))}
            height={entregaBarHeight}
            className={`fill-red-500 opacity-80 hover:opacity-100`}
            stroke={'black'}
            strokeWidth={0.5}

        />
        <g transform={`translate(${xScale(new Date(entrega.realDeliveryDate)) + 2}, ${y + 15})`}>
            <text className="text-sm font-bold">EF</text>
        </g>

        <rect
            x={xScale(new Date(entrega.publicDeliveryDate))}
            y={y}
            width={xScale(addDays(new Date(entrega.publicDeliveryDate), 1)) - xScale(new Date(entrega.publicDeliveryDate))}
            height={entregaBarHeight}
            className={`fill-purple-500 opacity-80 hover:opacity-100`}
            stroke={'black'}
            strokeWidth={0.5}

        />
        <g transform={`translate(${xScale(new Date(entrega.publicDeliveryDate)) + 2}, ${y + 15})`}>
            <text className="text-sm font-bold">EC</text>
        </g>

        <rect
            x={xScale(new Date(entrega.productionReadyDate))}
            y={y}
            width={xScale(addDays(new Date(entrega.productionReadyDate), 1)) - xScale(new Date(entrega.productionReadyDate))}
            height={entregaBarHeight}
            className={`fill-amber-500 opacity-80 hover:opacity-100`}
            stroke={'black'}
            strokeWidth={0.5}

        />
        <g transform={`translate(${xScale(new Date(entrega.productionReadyDate)) + 2}, ${y + 15})`}>
            <text className="text-sm font-bold">FP</text>
        </g>

        {/* {tooltip === operacao.id ? <Tooltip multiline height={100} width={tooltipWidth(operacao)} size={'sm'} x={xScale(addDays(new Date(operacao.dataExpedicao),2))} y={y + margins.top + 60} message={message(operacao, p)} position={'top'}/> : null} */}

    </g>)






}